import type { MapFeedItemDTO } from "../../data/types";

/**
 * Ritordningen för venue-pins.
 *
 * VARFÖR DEN HÄR FILEN FINNS: z-index låg tidigare i CSS på .venue-pin-inner,
 * alltså på pinnens *inre* element. Mapbox äger markörens rotelement och
 * positionerar det absolut, så varje markör bildar sin egen stapelkontext —
 * ett z-index på ett barn kan inte ordna markören mot andra markörer. Reglerna
 * såg alltså rätt ut och gjorde ingenting, och gråa pins hamnade slumpmässigt
 * ovanpå barer som spelade, beroende på i vilken ordning de råkade skapas.
 *
 * Värdet sätts därför på rotelementet, av venuePin.ts.
 *
 * Ordningen speglar STATUS_Z i beatmap-native/src/components/map/markerStyle.ts.
 * Ändras den ena, ändra den andra.
 */
export const PIN_Z = {
  LIVE: 30,
  RECENT: 20,
  TODAY: 10,
  /** Ställen utan betalplan eller påslagen sensor. Alltid underst. */
  NO_LIVE_DATA: 0,
} as const;

/**
 * Incheckade vänner lyfter pinnen inom sin egen statusnivå, aldrig förbi en
 * färskare. En grå bar där vänner står ska synas bland andra gråa barer —
 * men inte skymma en bar som spelar musik just nu.
 */
const PRESENCE_BONUS = 5;

export function venuePinZIndex(item: MapFeedItemDTO): number {
  const presence = item.checkedIn ? PRESENCE_BONUS : 0;

  if (item.hasLiveData === false) return PIN_Z.NO_LIVE_DATA + presence;

  switch (item.status) {
    case "LIVE":
      return PIN_Z.LIVE + presence;
    case "RECENT":
      return PIN_Z.RECENT + presence;
    case "TODAY":
      return PIN_Z.TODAY + presence;
    default:
      // Okänd status ska inte kunna lägga sig över något som spelar.
      return PIN_Z.NO_LIVE_DATA + presence;
  }
}

/** Egen position ligger över allt annat. Man ska aldrig tappa bort sig själv. */
export const USER_PIN_Z = 1000;
